import Storage from './Storage';

class AuthUtils {
  static setAuthToken(token: string): void {
    localStorage.setItem(Storage.KEYS.AUTH_TOKEN, token);
  }

  static getAuthToken(): string | null {
    const token = localStorage.getItem(Storage.KEYS.AUTH_TOKEN);
    return token;
  }

  static clearAuthToken(): void {
    Storage.removeItem(Storage.KEYS.AUTH_TOKEN);
  }

  static setPatientAuthToken(token: string): void {
    sessionStorage.setItem(Storage.KEYS.PATIENT_AUTH_TOKEN, token);
  }

  static getPatientAuthToken(): string | null {
    const token = sessionStorage.getItem(Storage.KEYS.PATIENT_AUTH_TOKEN);
    return token;
  }

  static clearPatientAuthToken(): void {
    Storage.removeSessionItem(Storage.KEYS.PATIENT_AUTH_TOKEN);
  }
  static setUser(user: any): void {
    Storage.setItem(Storage.KEYS.USER, user);
  }

  static getUser(): string | null {
    return Storage.getItem(Storage.KEYS.USER, true);
  }

  static clearUser(): void {
    Storage.removeItem(Storage.KEYS.USER);
  }

  static setUserType(UserType:string):void {
    localStorage.setItem(Storage.KEYS.USER_TYPE,UserType);
  }

  static getUserType(): string | null {
    return localStorage.getItem(Storage.KEYS.USER_TYPE);
  }

  static clearUserType(): void {
    Storage.removeItem(Storage.KEYS.USER_TYPE);
  }
}

export default AuthUtils;
